export const APP_TOGGLEDLEFTPANEL = 'app/TOGGLEDLEFTPANEL';
export const APP_TOGGLESEARCHOVERLAY = 'app/TOGGLESEARCHOVERLAY';
export const APP_TOGGLELOADED = 'app/LOADED';
export const APP_TOGGLESETTINGOVERLAY = 'app/TOGGLESETTINGOVERLAY';
export const APP_TOGGLEWATCHLISTOVERLAY = 'app/TOGGLEWATCHLISTOVERLAY';
export const APP_TOGGLEREFRESH = 'app/REFRESH';
export const APP_CONTINUE = 'app/TOGGLECONTINUE';
export const APP_LANGUAGE = 'app/LANGUAGE';
export const APP_SETTINGMODE = 'app/SETTINGMODE';
export const APP_SETTINGLANDING = 'app/SETTINGLANDING';
export const APP_FIRSTLOGIN = 'app/FIRSTLOGIN';

const currTimestamp = Math.round(new Date().getTime() / 1000);

if (localStorage.u) {
	const parseStorage = JSON.parse(localStorage.u);

	if (parseStorage.tokenExpiryTime) {
		if (currTimestamp > new Date(parseInt(parseStorage.tokenExpiryTime, 10)).getTime()) {
			localStorage.removeItem('u');
			// window.parent.location = `${window.parent.location.origin}/signin`;
		}
	}
}

const initialState = {
	toggledLeftPanel: false,
	searchOverlay: false,
	appLoaded: false,
	settingOverlay: false,
	watchlistOverlay: false,
	continueWatchShow: true,
	appLanguage: '',
	appSettingMode: 'profile',
	appLanding: true,
	appFirstLogin: false,
	appRefresh: false,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case APP_TOGGLEDLEFTPANEL:
			return {
				...state,
				toggledLeftPanel: !state.toggledLeftPanel
			};

		case APP_TOGGLESEARCHOVERLAY:
			return {
				...state,
				searchOverlay: !state.searchOverlay
			};

		case APP_TOGGLELOADED:
			return {
				...state,
				appLoaded: !state.appLoaded
			};

		case APP_TOGGLESETTINGOVERLAY:
			return {
				...state,
				settingOverlay: !state.settingOverlay
			};

		case APP_TOGGLEWATCHLISTOVERLAY:
			return {
				...state,
				watchlistOverlay: !state.watchlistOverlay
			};

		case APP_TOGGLEREFRESH:
			return {
				...state,
				appRefresh: !state.appRefresh
			};

		case APP_CONTINUE:
			return {
				...state,
				continueWatchShow: action.payload
			};

		case APP_LANGUAGE:
			return {
				...state,
				appLanguage: action.payload
			};

		case APP_SETTINGMODE:
			return {
				...state,
				appSettingMode: action.payload
			};

		case APP_SETTINGLANDING:
			return {
				...state,
				appLanding: action.payload
			};

		case APP_FIRSTLOGIN:
			return {
				...state,
				appFirstLogin: action.payload
			};

		

		default:
			return state;
		
	}
};

export const appToggledLeftPanel = () => {
	return dispatch => {
		dispatch({
			type: APP_TOGGLEDLEFTPANEL
		});
	};
};

export const appToggleSearchOverlay = () => {
	return dispatch => {
		dispatch({
			type: APP_TOGGLESEARCHOVERLAY
		});
	};
};

export const appToggleLoaded = () => {
	return dispatch => {
		dispatch({
			type: APP_TOGGLELOADED
		});
	};
};

export const appToggleSettingOverlay = () => {
	return dispatch => {
		dispatch({
			type: APP_TOGGLESETTINGOVERLAY
		});
	};
};

export const appToggleWatchlistOverlay = () => {
	return dispatch => {
		dispatch({
			type: APP_TOGGLEWATCHLISTOVERLAY
		});
	};
};

export const appToggleRefresh = () => {
	return dispatch => {
		dispatch({
			type: APP_TOGGLEREFRESH,
		});
	};
};

export const appSetContinue = (data) => {
	return dispatch => {
		dispatch({
			type: APP_CONTINUE,
			payload: data,
		});
	};
};

export const appSetLanguage = (data) => {
	return dispatch => {
		dispatch({
			type: APP_LANGUAGE,
			payload: data,
		});
	};
};

export const appSetMode = (data) => {
	return dispatch => {
		dispatch({
			type: APP_SETTINGMODE,
			payload: data,
		});
	};
};

export const appSendAnalytics = (data) => {
	return dispatch => {
		dispatch({
			type: APP_SETTINGMODE,
			payload: data,
		});
	};
};

export const appSetLanding = (data) => {
	return dispatch => {
		dispatch({
			type: APP_SETTINGLANDING,
			payload: data,
		});
	};
};

export const appSetFirstLogin = (data) => {
	return dispatch => {
		dispatch({
			type: APP_FIRSTLOGIN,
			payload: data,
		});
	};
};
